module.exports = __webpack_public_path__ + "img/falls-goal-dropdown.3fc400cc.gif";